import React from 'react';
import { StickyAlert } from '../components/StickyAlert';
import { StickyBonusCTA } from '../components/StickyBonusCTA';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BonusSection } from '../components/BonusSection';
import { ImageSlider } from '../components/ImageSlider';
import { FacebookReviews } from '../components/FacebookReviews';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-298">
      <StickyAlert data-id="element-299" />
      <StickyBonusCTA data-id="element-300" />
      <HeroSection data-id="element-301" />
      <ProblemSection data-id="element-302" />
      <SolutionSection data-id="element-303" />
      <BonusSection data-id="element-304" />
      <ImageSlider data-id="element-305" />
      <GuaranteeSection data-id="element-306" />
      <FacebookReviews data-id="element-307" />
      <FAQSection data-id="element-308" />
      <Footer data-id="element-309" />
    </div>;
}